import { KeyboardEventHandler, useCallback, useEffect } from 'react'
import SendIcon from '@ui-components-3/icons/lib/duotone/PaperPlaneTop'
import Input, { InputProps } from '@ui-components-3/ui/lib/components/Input'
import { Merge } from '@ui-components-3/ui/lib/types'
import { SubmitHandler, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import MessageSchema from 'schemas/Message'
import { InferType } from 'yup'

/* 
    TODO:
        add types after typing models
*/
type MessageTextareaProps = Merge<
  InputProps,
  {
    visit: any
  }
>

type FormValues = InferType<typeof MessageSchema>

const MessageTextarea = ({ visit, className }: MessageTextareaProps) => {
  const {
    register,
    handleSubmit,
    reset,
    setFocus,
    formState: { isDirty, isSubmitting, isValid },
  } = useForm<FormValues>({
    mode: 'onChange',
    resolver: yupResolver(MessageSchema),
  })

  const sendMessage: SubmitHandler<FormValues> = async (values) => {
    await visit.chat.sendMessage(values.message)
    reset(
      {
        message: '',
      },
      {
        keepDirty: true,
      },
    )
  }

  const handleKeyDown = useCallback<KeyboardEventHandler<HTMLElement>>(
    (e) => {
      if (e.key === 'Enter' && e.shiftKey === false) {
        e.preventDefault()
        if (isValid) {
          handleSubmit(sendMessage)()
        }
      }
    },
    [sendMessage, isValid],
  )

  const shouldFocus = isDirty && !isSubmitting

  useEffect(() => {
    if (shouldFocus) {
      setFocus('message')
    }
  }, [shouldFocus])

  return (
    <form onSubmit={handleSubmit(sendMessage)} className="w-full flex justify-center">
      <Input
        spellCheck={true}
        {...register('message')}
        autoComplete={'off'}
        placeholder="Message"
        className={className}
        onKeyDown={handleKeyDown}
        rows={3}
        multiline
        disabled={isSubmitting || visit.status === 'in-review'}
        suffix={
          <button type="submit" disabled={!isValid || isSubmitting} className="btn-tiny btn-primary-borderless">
            <SendIcon aria-label="Send" className="h-m" />
          </button>
        }
      />
    </form>
  )
}

export default MessageTextarea
